import { useState, useRef, useEffect } from 'react'
import clsx from 'clsx'
import type { ReactNode } from 'react'

interface DropdownProps {
  trigger: ReactNode
  children: ReactNode
  align?: 'left' | 'right'
  className?: string
}

export default function Dropdown({ trigger, children, align = 'right', className }: DropdownProps) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  return (
    <div ref={ref} className={clsx('relative', className)}>
      <div onClick={() => setOpen(!open)}>{trigger}</div>
      {open && (
        <div className={clsx(
          'absolute top-full mt-2 z-40 min-w-[180px] rounded-2xl border border-gray-200 bg-white p-2 shadow-lg animate-scale-in',
          align === 'right' ? 'right-0' : 'left-0',
        )}>
          <div onClick={() => setOpen(false)}>
            {children}
          </div>
        </div>
      )}
    </div>
  )
}

function DropdownItem({ children, onClick, danger, className }: {
  children: ReactNode
  onClick?: () => void
  danger?: boolean
  className?: string
}) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors text-left',
        danger
          ? 'text-error-600 hover:bg-error-50'
          : 'text-gray-700 hover:bg-gray-100',
        className,
      )}
    >
      {children}
    </button>
  )
}

export { DropdownItem }
